import { ThemeUtils, UrlUtils } from "../utils/index.js";
import React, { useMemo } from "react";
import { UISelectors, UserContextSelectors } from "../redux/selectors/index.js";
import { LogoState } from "./LogoState.js";
import PropTypes from "prop-types";
import SILinks from "../segmentedComponents/SI-links/index.js";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { LocalizationMessages } from "../localization/messages.js";
import { useIntl } from "react-intl";
import { ImgComponent } from "./common/ImgComponent.js";
import { TrackingInfo } from "./tracking/TrackingInfoHeader.js";

const Logo = props => {
  const { onClick, id, className, showAltLogo } = props;
  const { formatMessage } = useIntl();
  const config = useSelector(UISelectors.config);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const isVITheme = ThemeUtils.isVITheme();
  const onClickHandler = evt => {
    if (typeof onClick === "function") onClick(evt);
  };

  const trackingInfoLocal = useMemo(
    () =>
      TrackingInfo
        ? Object.assign({}, TrackingInfo, { dataLabel: "logo" })
        : Object.assign({}, TrackingInfo, {
            dataCategory: "header",
            dataAction: "click",
            dataLabel: "logo"
          }),
    []
  );

  const logoClasses = useMemo(
    () => classNames("aClogoBox", className),
    [className]
  );

  const logo = useMemo(() => {
    if (isMobile && config?.logoMobile) {
      return config?.logoMobile;
    } else {
      return config?.logo;
    }
  }, [config?.logo, config?.logoMobile, isMobile]);

  const logoAlt = useMemo(
    () => config?.logoAlt ?? config?.logo,
    [config?.logo, config?.logoAlt]
  );

  const iconName = useMemo(() => {
    if (isVITheme && config?.logoVI) {
      return config?.logoVI;
    }
    if (showAltLogo) {
      return logoAlt;
    }
    return logo;
  }, [isVITheme, config?.logoVI, showAltLogo, logoAlt, logo]);

  return (
    <>
      <div id={id} className={logoClasses}>
        {!isMobile && ThemeUtils.isSITheme() && <SILinks />}
        <ImgComponent
          onClick={onClickHandler}
          className="logoSVG"
          iconName={iconName}
          alt={formatMessage(LocalizationMessages.seoLogoText)}
          hasLoadingIcon
          link={{
            href: UrlUtils.getCurrentOriginURLWithLang(window.location.origin),
            dataCategory: trackingInfoLocal.dataCategory,
            dataAction: trackingInfoLocal.dataAction,
            dataLabel: trackingInfoLocal.dataLabel,
            value: "",
            className: "logo-link"
          }}
        >
          <LogoState />
        </ImgComponent>
      </div>
    </>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  showAltLogo: PropTypes.bool
};

export default Logo;
